// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  Field,
  FormSection,
} from 'redux-form';
import { ReduxFormLabeledInput } from '../../../form/labeledFields';
import { ReduxFormInput } from '../../../form';
import { required } from '../../../../helpers/formValidators';
import {
  AddressContainer,
  AddressItem,
  LabeledField,
  Label,
} from './style';
import type { OwnProps } from './types';

const Address = ({
  fetchAddress,
  requiredErrorMessage,
  label,
  postalCodePlaceholder,
  houseNumberPlaceholder,
  houseNumberSuffixPlaceholder,
  streetLabel,
  cityLabel,
}: OwnProps) => {
  const validators = {
    required: required(requiredErrorMessage),
  };
  const updateAddress = () => {
    if (process.env.LISTO_ORDERFORM_ZIPCODE_AUTOCOMPLETE === 'true') {
      fetchAddress('address');
    }
  };
  return (
    <FormSection name="address">
      <LabeledField>
        <Label>{label}</Label>
        <AddressContainer>
          <AddressItem>
            <Field
              component={ReduxFormInput}
              name="postal_code"
              type="text"
              placeholder={postalCodePlaceholder}
              onBlur={() => updateAddress()}
              validate={[validators.required]}
            />
          </AddressItem>
          <AddressItem>
            <Field
              component={ReduxFormInput}
              name="house_number"
              type="number"
              placeholder={houseNumberPlaceholder}
              onBlur={() => updateAddress()}
              validate={[validators.required]}
            />
          </AddressItem>
          <AddressItem>
            <Field
              component={ReduxFormInput}
              name="house_number_suffix"
              type="text"
              placeholder={houseNumberSuffixPlaceholder}
            />
          </AddressItem>
        </AddressContainer>
      </LabeledField>
      <Field
        component={ReduxFormLabeledInput}
        name="street"
        type="text"
        label={streetLabel}
        validate={[validators.required]}
      />
      <Field
        component={ReduxFormLabeledInput}
        name="city"
        type="text"
        label={cityLabel}
        validate={[validators.required]}
      />
    </FormSection>
  );
};

// Connect to an empty store, because redux-form needs it in order to function.
export default connect<any, OwnProps, void, void, any, any>(null)(Address);
